module.exports = __webpack_public_path__ + "static/media/Thumbs.0e456650.db";